import { render } from "./Follow.vue?vue&type=template&id=3eb4630f&scoped=true"
import script from "./Follow.vue?vue&type=script&lang=js"
export * from "./Follow.vue?vue&type=script&lang=js"

import "./Follow.vue?vue&type=style&index=0&id=3eb4630f&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb4630f"]])

export default __exports__